module.exports = __webpack_public_path__ + "img/word_carpet_mask.09169c9b.svg";